module.exports = __webpack_public_path__ + "static/intro_about_mobile-b32c35c116d33c7046fb3c90cbb4050d.png";